import React from "react";

function Project({ title, imgurl, about, learned, githubLink, projectLink }) {
  return (
    <div className="max-w-sm rounded overflow-hidden shadow-lg">
      <img className="w-full" src={imgurl} alt="Project" loading="lazy" />
      <div className="px-6 py-4">
        <div className="font-bold text-2xl mb-2">{title}</div>
        <p className="text-gray-700 text-base">{about}</p>
      </div>

      <div className="px-6 pt-4 pb-2">
        <h3 className="font-bold text-l mb-2">Things I learned</h3>
        {learned.map((learnedItem) => (
          <span
            key={learnedItem}
            className="inline-block bg-gray-400 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2"
          >
            {learnedItem}
          </span>
        ))}
      </div>
      <div className="px-6 pt-4 pb-8">
        {githubLink && (
          <a
            className="mr-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            href={githubLink}
          >
            Github Link
          </a>
        )}
        {projectLink && (
          <a
            className="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded"
            href={projectLink}
          >
            Project Link
          </a>
        )}
      </div>
    </div>
  );
}

export default Project;
